<template>
  <div class="language-switcher" :class="{ 'language-switcher--dark': dark }" role="group" aria-label="Language selector">
    <button
      v-for="item in languages"
      :key="item.value"
      type="button"
      :class="{ 'language-switcher__btn--active': $i18n.locale === item.value }"
      class="language-switcher__btn"
      @click="changeLocale(item.value)"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<script>
import { setLocale } from '@/i18n'

export default {
  name: 'LanguageSwitcher',
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      languages: [
        { value: 'kk', label: 'ҚАЗ' },
        { value: 'ru', label: 'РУС' },
      ],
    }
  },
  methods: {
    changeLocale(locale) {
      setLocale(locale)
      this.$emit('change', locale)
    },
  },
}
</script>

<style scoped lang="scss">
.language-switcher {
  display: inline-flex;
  padding: 3px;
  border: 1px solid #d9e2ec;
  border-radius: 10px;
  background: #f4f7fa;
}

.language-switcher__btn {
  border: 0;
  border-radius: 7px;
  padding: 5px 7px;
  background: transparent;
  color: #6b7a90;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .02em;
  cursor: pointer;

  &--active {
    background: #fff;
    color: #0b4f8a;
    box-shadow: 0 1px 3px rgba(18, 32, 51, .12);
  }
}

.language-switcher--dark {
  border-color: rgba(255, 255, 255, .2);
  background: rgba(255, 255, 255, .1);

  .language-switcher__btn {
    color: rgba(255, 255, 255, .65);

    &--active {
      background: #fff;
      color: #0b4f8a;
    }
  }
}
</style>
